import { PackageType } from '__generated__/GQL';

import { OnboardingPackageItem } from '../../../machine/model';
import CreditCard from '../assets/CreditCard@2x.png';
import Fireworks from '../assets/Fireworks@2x.png';
import FloatingCash from '../assets/FloatingCash@2x.png';
import locales from '../locales';
import formatPrice from './formatPrice';

interface GetPackageRecapFieldsProps {
  pack: OnboardingPackageItem;
}

const getPackageIcon = ({ packageType }: { packageType: PackageType }) =>
  ({
    [PackageType.CapitalDeposit]: FloatingCash,
    [PackageType.ShineStart]: Fireworks,
  })[packageType];

const getPackageRecapFields = ({ pack }: GetPackageRecapFieldsProps) => {
  return {
    bankAccount: {
      label: locales.formatString(
        locales.claims.bankAccountIncludedFor,
        pack.trialPeriod,
      ),
      secondary: locales.formatString(locales.claims.pricePlan, {
        price: formatPrice(pack.plan.priceWithoutVAT),
        taxMention: locales.vat.excluded,
      }),
    },
    cardTitle: locales.formatString(locales.plans[pack.type].title, {
      brandName: pack.plan.brandName,
    }),
    claims: [
      {
        icon: getPackageIcon({ packageType: pack.type }),
        label: locales.packageTypes[pack.type],
      },
      {
        icon: CreditCard,
        label: locales.formatString(locales.planDescription, {
          brandName: pack.plan.brandName,
          months: pack.trialPeriod,
        }),
      },
    ],
    color: pack.plan.brandColor,
    packageName: locales.formatString(locales.plans[pack.type].title, {
      brandName: pack.plan.brandName,
    }),
    pageTitle: locales.title,
  };
};

export default getPackageRecapFields;
